import React from 'react';

import * as helpers from './helpers';

const RingWidthIcon = ({
  color,
  width = 54,
  height = 53,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg {...helpers.getSvgDimensionsProps({ width, height })} {...props}>
    <path
      d="M41.3046 26.3795C41.3046 42.6931 32.28 52.759 22.9084 52.759C21.6099 52.759 18.2861 52.759 17.0077 52.759C6.08096 52.759 25.6853 45.817 25.6853 26.3795C25.6853 7.98327 6.96355 -0.000228635 17.0077 4.91088e-09C17.7019 1.58073e-05 22.205 1.67346e-07 22.9084 1.67346e-07C33.8351 1.67346e-07 41.3046 10.0659 41.3046 26.3795Z"
      fill="#C3A573"
    />
    <path
      d="M6.24772 6.59488H20.4788C20.4788 6.59488 13.5368 12.1485 13.5368 26.0324C13.5368 39.9163 20.4788 46.1641 20.4788 46.1641H6.94191L5.20642 26.0324L6.24772 6.59488Z"
      fill="#C4C4C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6906 41.4957C22.7804 37.9664 24.2969 32.6381 24.2969 26.3795C24.2969 20.1209 22.7804 14.7925 20.6906 11.2633C18.5104 7.58109 16.4904 6.94197 15.6194 6.94197C14.7484 6.94197 12.7284 7.58109 10.5482 11.2633C8.45852 14.7925 6.94197 20.1209 6.94197 26.3795C6.94197 32.6381 8.45852 37.9664 10.5482 41.4957C12.7284 45.1779 14.7484 45.817 15.6194 45.817C16.4904 45.817 18.5104 45.1779 20.6906 41.4957ZM15.6194 52.759C24.2458 52.759 31.2389 40.9485 31.2389 26.3795C31.2389 11.8105 24.2458 0 15.6194 0C6.99306 0 0 11.8105 0 26.3795C0 40.9485 6.99306 52.759 15.6194 52.759Z"
      fill="#F0F0F0"
    />
    <path
      d="M19 25.25C18.5858 25.25 18.25 25.5858 18.25 26C18.25 26.4142 18.5858 26.75 19 26.75L19 25.25ZM30.5303 26.5303C30.8232 26.2374 30.8232 25.7626 30.5303 25.4697L25.7574 20.6967C25.4645 20.4038 24.9896 20.4038 24.6967 20.6967C24.4038 20.9896 24.4038 21.4645 24.6967 21.7574L28.9393 26L24.6967 30.2426C24.4038 30.5355 24.4038 31.0104 24.6967 31.3033C24.9896 31.5962 25.4645 31.5962 25.7574 31.3033L30.5303 26.5303ZM19 26.75L30 26.75L30 25.25L19 25.25L19 26.75Z"
      fill="#444449"
    />
    <path
      d="M53 25.25C53.4142 25.25 53.75 25.5858 53.75 26C53.75 26.4142 53.4142 26.75 53 26.75L53 25.25ZM41.4697 26.5303C41.1768 26.2374 41.1768 25.7626 41.4697 25.4697L46.2426 20.6967C46.5355 20.4038 47.0104 20.4038 47.3033 20.6967C47.5962 20.9896 47.5962 21.4645 47.3033 21.7574L43.0607 26L47.3033 30.2426C47.5962 30.5355 47.5962 31.0104 47.3033 31.3033C47.0104 31.5962 46.5355 31.5962 46.2426 31.3033L41.4697 26.5303ZM53 26.75L42 26.75L42 25.25L53 25.25L53 26.75Z"
      fill="#444449"
    />

  </svg>
);

export default RingWidthIcon;
